const ACCOUNTS = [
  ["1010", "Cash on Hand", "A"],
  ["1020", "Cash in Bank – Operating", "A"],
  ["1110", "Accounts Receivable – Clients", "A"],
  ["1120", "Retention Receivable", "A"],
  ["1130", "Unbilled Revenue (Contract Assets)", "A"],
  ["1410", "Input VAT", "A"],
  ["1420", "Creditable Withholding Tax (2307s)", "A"],
  ["1430", "Prepaid Income Tax (1702Q)", "A"],
  ["1450", "Prepayments & Deposits", "A"],
  ["1510", "Engineering Equipment & Software", "A"],
  ["1520", "Accumulated Depreciation", "A", 1],
  ["2140", "13th Month Pay Payable", "L"],
  ["2110", "Accounts Payable – Suppliers & Subconsultants", "L"],
  ["2120", "Advances from Clients (Contract Liabilities)", "L"],
  ["2210", "SSS & EC Payable", "L"],
  ["2220", "PhilHealth Payable", "L"],
  ["2225", "Pag-IBIG Payable", "L"],
  ["2230", "Expanded Withholding Tax Payable", "L"],
  ["2235", "Withholding Tax on Compensation Payable", "L"],
  ["2240", "Output VAT", "L"],
  ["2260", "Salaries Payable", "L"],
  ["3010", "Share Capital", "E"],
  ["3020", "Retained Earnings", "E"],
  ["4010", "Consultancy & Engineering Fees", "R"],
  ["4020", "Manpower & Site Works", "R"],
  ["5101", "13th Month Pay Accrual", "X"],
  ["5100", "Direct Labor – Project Personnel", "X"],
  ["5110", "Subconsultants", "X"],
  ["5120", "Site Travel & Mobilization", "X"],
  ["5010", "Salaries – Administration", "X"],
  ["5050", "SSS (Employer)", "X"],
  ["5055", "EC (Employer)", "X"],
  ["5060", "PhilHealth (Employer)", "X"],
  ["5070", "Pag-IBIG (Employer)", "X"],
  ["5220", "Office Rent", "X"],
  ["5230", "Utilities & Communications", "X"],
  ["5240", "Professional Liability Insurance", "X"],
  ["5250", "Depreciation", "X"],
  ["5260", "Engineering Software Subscriptions", "X"],
];

const COS = ["5100", "5110", "5120"];

const ACC = Object.fromEntries(
  ACCOUNTS.map((a) => [
    a[0],
    { code: a[0], name: a[1], type: a[2], contra: !!a[3] },
  ]),
);

const PERMS = {
  "gl.view": "View general ledger",
  "gl.create": "Prepare journal vouchers",
  "gl.approve": "Approve & post vouchers",
  "fs.view": "Financial statements",
  "period.lock": "Lock accounting periods",
  "proj.view": "Projects",
  "inv.issue": "Issue invoices & record payments",
  "bir.view": "BIR compliance",
  "bir.file": "Mark returns filed",
  "hr.view": "Employee directory",
  "hr.salary": "Salaries & gov't IDs",
  "leave.team": "Approve own team's leave",
  "leave.all": "Approve all leave",
  "dep.view": "Deployments",
  "dep.manage": "Deploy personnel & set rates",
  "dep.log": "Keep site time records",
  "pay.view": "View payroll",
  "pay.prepare": "Prepare payroll",
  "pay.approve": "Approve payroll",
  "pay.release": "Release payroll",
  ess: "Employee self-service",
  "audit.view": "Audit trail",
  "admin.users": "Users & roles",
  "sys.admin": "System administration",
};

export function permissionsForRole(roles, role) {
  return role === "SUPER" ? Object.keys(PERMS) : roles[role]?.perms || [];
}

const DEFAULT_ROLES = {
  SUPER: {
    name: "Superadmin",
    perms: Object.keys(PERMS),
  },
  OWNER: { name: "Owner / President", perms: Object.keys(PERMS) },
  FIN: {
    name: "Finance Manager",
    perms: [
      "dep.view",
      "inv.issue",
      "gl.view",
      "gl.create",
      "gl.approve",
      "fs.view",
      "proj.view",
      "bir.view",
      "bir.file",
      "hr.view",
      "pay.view",
      "pay.approve",
      "pay.release",
      "audit.view",
      "ess",
    ],
  },
  ACCT: {
    name: "Accountant",
    perms: [
      "dep.view",
      "inv.issue",
      "gl.view",
      "gl.create",
      "fs.view",
      "proj.view",
      "bir.view",
      "ess",
    ],
  },
  HR: {
    name: "HR Manager",
    perms: [
      "dep.view",
      "dep.manage",
      "dep.log",
      "hr.view",
      "hr.salary",
      "leave.all",
      "pay.view",
      "pay.prepare",
      "audit.view",
      "ess",
    ],
  },
  PAY: {
    name: "Payroll Officer",
    perms: [
      "dep.view",
      "dep.log",
      "hr.view",
      "hr.salary",
      "pay.view",
      "pay.prepare",
      "ess",
    ],
  },
  HEAD: {
    name: "Engineering Director",
    perms: ["dep.view", "dep.log", "hr.view", "proj.view", "leave.team", "ess"],
  },
  EMP: { name: "Employee", perms: ["ess"] },
  AUD: {
    name: "External Auditor",
    perms: [
      "dep.view",
      "gl.view",
      "fs.view",
      "proj.view",
      "bir.view",
      "pay.view",
      "audit.view",
    ],
  },
};

const LEAVE_TYPES = {
  SIL: "Service Incentive Leave (Art. 95, 5 days)",
  VL: "Vacation Leave (company, 10 days)",
  SL: "Sick Leave (company, 10 days)",
  PAT: "Paternity Leave (RA 8187, 7 days)",
  MAT: "Maternity Leave (RA 11210, 105 days)",
  SOLO: "Solo Parent Leave (RA 11861, 7 days)",
  VAWC: "VAWC Leave (RA 9262, 10 days)",
};

const LEAVE_CAP = {
  SIL: 5,
  VL: 10,
  SL: 10,
  PAT: 7,
  MAT: 105,
  SOLO: 7,
  VAWC: 10,
};

const TIN_RE = /^\d{3}-\d{3}-\d{3}-\d{3,5}$/;

export {
  ACCOUNTS,
  COS,
  ACC,
  PERMS,
  DEFAULT_ROLES,
  LEAVE_TYPES,
  LEAVE_CAP,
  TIN_RE,
};
